import { StrategicAxis, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeStrategicAxis(httpClient: HttpClient) {
  return (strategicAxis: StrategicAxis) =>
    new Promise<Identifiable<StrategicAxis>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<void>({
          endpoint: `/strategicAxeses/${strategicAxis.uuid}`,
          method: HttpMethods.DELETE,
        })
        .then(() => resolve(strategicAxis))
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { removeStrategicAxis };
